var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpotifyLargeContainer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 510,
    height: 239,
    viewBox: "0 0 510 239",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_208_17305)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_208_17305",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 510,
    height: 244,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 510,
    height: 244
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 24.837L15 14.3965L24 5H485L495 15L505 25V239H5V24.837Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 24.837L15 14.3965L24 5H485L495 15L505 25V239H5V24.837Z",
    fill: "url(#paint0_linear_208_17305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.3965L11.3891 10.9379V10.9379L15 14.3965ZM5 24.837L1.38911 21.3785L0 22.8288V24.837H5ZM24 5V0H21.8655L20.3891 1.54147L24 5ZM485 5L488.536 1.46447L487.071 0H485V5ZM505 25H510V22.9289L508.536 21.4645L505 25ZM505 239V244H510V239H505ZM5 239H0V244H5V239ZM11.3891 10.9379L1.38911 21.3785L8.61089 28.2955L18.6109 17.855L11.3891 10.9379ZM20.3891 1.54147L11.3891 10.9379L18.6109 17.855L27.6109 8.45853L20.3891 1.54147ZM485 0H24V10H485V0ZM498.536 11.4645L488.536 1.46447L481.464 8.53553L491.464 18.5355L498.536 11.4645ZM508.536 21.4645L498.536 11.4645L491.464 18.5355L501.464 28.5355L508.536 21.4645ZM510 239V25H500V239H510ZM5 244H505V234H5V244ZM0 24.837V239H10V24.837H0Z",
    fill: "url(#paint1_linear_208_17305)",
    mask: "url(#path-1-outside-1_208_17305)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_208_17305",
    x: -35,
    y: -35,
    width: 580,
    height: 314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_208_17305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_208_17305",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_17305",
    x1: 257,
    y1: 5,
    x2: 255,
    y2: 242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#1B1B23",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#1B1B23",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#1B1B23",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B23",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_17305",
    x1: 257,
    y1: 5,
    x2: 257,
    y2: 242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#BEAEFF",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpotifyLargeContainer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spotifyLargeContainer.74adcd805ee36edde3415a43dd7a2364.svg";